import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { comparison } from '../mock';
import Reveal from './Reveal';

const Comparison = () => {
  return (
    <section className="relative">
      <div className="grid md:grid-cols-2 relative">
        {/* Before */}
        <div
          className="relative min-h-[420px] bg-cover bg-center"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1200&q=80')" }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10" />
          <Reveal variant="left" className="relative z-10">
            <div className="p-10 md:p-14 text-white max-w-md">
              <div className="text-[11px] tracking-[0.3em] text-white/70 mb-3">BEFORE</div>
              <h3 className="text-3xl font-bold mb-6">Traditional Home</h3>
              <ul className="space-y-3">
                {comparison.before.map((b) => (
                  <li key={b} className="flex items-center gap-3 text-[15px]">
                    <XCircle size={20} className="text-red-400 shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        {/* After */}
        <div
          className="relative min-h-[420px] bg-cover bg-center"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1200&q=80')" }}
        >
          <div className="absolute inset-0 bg-gradient-to-l from-[#0B1430]/80 via-[#0B1430]/50 to-[#0B1430]/10" />
          <Reveal variant="right" className="relative z-10">
            <div className="p-10 md:p-14 text-white max-w-md ml-auto">
              <div className="text-[11px] tracking-[0.3em] text-[#D4A853] mb-3">AFTER</div>
              <h3 className="text-3xl font-bold mb-6">Smart Home</h3>
              <ul className="space-y-3">
                {comparison.after.map((b) => (
                  <li key={b} className="flex items-center gap-3 text-[15px]">
                    <CheckCircle2 size={20} className="text-[#D4A853] shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        {/* VS badge */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
          <div className="w-16 h-16 rounded-full bg-white shadow-xl flex items-center justify-center font-bold text-[#0B1430]">
            VS
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
